import type React from "react";
import { useTranslation } from "react-i18next";
import {
	PrimaryButton,
	TextPrimaryButton,
} from "src/components/Default/LekUI/Button";
import {
	Modal,
	ModalContent,
	ModalFooter,
	ModalTitle,
} from "src/components/Modals/Components/ModalsComponents";
import WarningIcon from "src/images/Icons/newIcons/warrning.svg";
import { ModalMaxWidth } from "src/types/enums";

interface ConfirmationModalProps {
	onClose: () => void;
	onConfirm: () => Promise<void>;
	title: string;
	children?: React.ReactNode;
	isLoading?: boolean;
}

export const ConfirmationModal = ({
	onClose,
	onConfirm,
	title,
	children,
	isLoading,
}: ConfirmationModalProps) => {
	const { t } = useTranslation();

	const confirm = async () => {
		await onConfirm();
		onClose();
	};

	return (
		<Modal onClose={onClose} maxWidth={ModalMaxWidth.sm}>
			<ModalTitle title={title} Icon={WarningIcon} />
			<ModalContent>{children}</ModalContent>
			<ModalFooter>
				<TextPrimaryButton onClick={onClose}>
					{t("commands.cancel")}
				</TextPrimaryButton>
				<PrimaryButton
					data-test-id="confirmation-modal-confirm-button"
					isLoading={isLoading}
					onClick={confirm}
				>
					{t("commands.confirm")}
				</PrimaryButton>
			</ModalFooter>
		</Modal>
	);
};
